import { cn } from "@/lib/utils";

type TErrorAlertVariant = "inline" | "banner" | "card";

type TErrorAlertProps = {
  message: string;
  variant?: TErrorAlertVariant;
  className?: string;
};

const variantClasses: Record<TErrorAlertVariant, string> = {
  inline: "text-xs text-destructive sm:text-sm",
  banner: "rounded-md bg-red-50 p-3 text-sm text-red-800",
  card: "rounded-lg border border-red-200 bg-red-50 p-2 text-xs text-red-800",
};

export function ErrorAlert({ message, variant = "inline", className }: TErrorAlertProps) {
  if (!message) return null;

  const Tag = variant === "inline" ? "p" : "div";

  return <Tag role="alert" className={cn(variantClasses[variant], className)}>{message}</Tag>;
}

/** @deprecated Use ErrorAlert instead */
export function InlineError({ message, className }: { message: string; className?: string }) {
  return <ErrorAlert message={message} variant="inline" className={className} />;
}
